import { http } from '@/http/axios';
import type { StripeConnectAccount, StripeConnectedPricePage } from '@/lib/stripeConnect';

export const stripeConnectService = {
  getAccount: async (workspaceId: number): Promise<StripeConnectAccount> => {
    const response = await http.get<StripeConnectAccount>(
      `/workspaces/${workspaceId}/stripe-connect`,
    );
    return response.data;
  },

  // URL d'autorisation Stripe à ouvrir : le retour se fait sur la page Intégrations.
  createAuthorization: async (workspaceId: number): Promise<string> => {
    const response = await http.post<{ authorizationUrl: string }>(
      `/workspaces/${workspaceId}/stripe-connect/authorization`,
    );
    return response.data.authorizationUrl;
  },

  disconnect: async (workspaceId: number): Promise<void> => {
    await http.delete(`/workspaces/${workspaceId}/stripe-connect`);
  },

  listPrices: async (
    workspaceId: number,
    cursor?: string | null,
  ): Promise<StripeConnectedPricePage> => {
    const response = await http.get<StripeConnectedPricePage>(
      `/workspaces/${workspaceId}/stripe-connect/prices`,
      { params: cursor ? { cursor } : undefined },
    );
    return response.data;
  },
};
